module.exports = __webpack_public_path__ + "img/ic_back_header-light.d4b3f1f.svg";